import { filter, find, includes, isEmpty, map, orderBy } from 'lodash'
import React, { useEffect, useState } from 'react'
import Carousel from 'react-multi-carousel'

import useHomepage from '../../hooks/useHomepage'
import useVisibility from '../../hooks/useVisibility'
import { Plan as PlanType } from '../../types'
import ScrollAnimation from '../scroll-animation/Container'
import CustomDot from './CustomDot'
import Heading from './Heading'
import Plan from './Plan'
import Taxes from './Taxes'
import { carouselBreakpoint, responsive } from './helpers'
import './plans.less'

const PlansContainer = () => {
  const { plans, productOffering, activeCityName, cities, animationProps, onNyLunchPage, onSfLunchPage } = useHomepage()
  const [currentPlans, setCurrentPlans] = useState<PlanType[]>([])
  const [isSectionInView, parrentElement] = useVisibility<HTMLDivElement>(100)
  const [animation, setAnimation] = useState<string>('')
  const isMobile = typeof window != 'undefined' && window.innerWidth < carouselBreakpoint
  const overrideProductOffering = productOffering === 'delivery' ? 'dinner' : productOffering

  useEffect(() => {
    const animationSource = isSectionInView ? `/arrow-animation.gif?a=${Math.random()}` : ''
    setAnimation(animationSource)
  }, [isSectionInView])

  useEffect(() => {
    if (!isEmpty(plans) && !isEmpty(cities)) {
      const sfLunchPlans = orderBy(
        filter(plans, (plan) =>
          includes(['6794d87d-92c5-4be0-8680-a2801f8b1d8e', '6bd5cbd8-7bbf-4cae-8667-721b07ef94ec'], plan.id),
        ),
        'order',
      )
      const activeCity = find(cities, (city) => city.name.toLowerCase() === activeCityName.toLowerCase())
      const currentPlans = orderBy(
        filter(
          plans,
          (plan: PlanType) => plan.productOffering === overrideProductOffering && plan.city.id === activeCity?.id,
        ),
        'plan_meal_kits.standard.meal_credits_issued',
      ).slice(0, 2)

      setCurrentPlans(onNyLunchPage ? currentPlans : onSfLunchPage ? sfLunchPlans : currentPlans)
    }
  }, [plans, cities, activeCityName, onNyLunchPage, onSfLunchPage])

  return (
    <div className={`plans plans--${productOffering}`} ref={parrentElement}>
      <Heading productOffering={productOffering} />
      <ScrollAnimation {...animationProps} animateIn={isMobile ? 'fadeInUp' : 'defaultAnimation'}>
        <Carousel
          className="plans__carousel"
          responsive={responsive}
          showDots={true}
          arrows={false}
          itemClass="plans__carousel-item"
          customDot={<CustomDot currentPlans={currentPlans} />}
        >
          {map(currentPlans, (plan: PlanType, index: number) => (
            <Plan animation={animation} plan={plan} index={index} key={index} />
          ))}
        </Carousel>
      </ScrollAnimation>
      <Taxes plans={currentPlans} />
    </div>
  )
}

export default PlansContainer
